import React from 'react';
import { CalendarRange } from 'lucide-react';
import { PRESETS } from './periods';

export const PeriodPicker = ({ preset, start, end, onPreset, onCustom }) => (
  <div className="flex flex-col lg:flex-row lg:items-center gap-3" data-testid="period-picker">
    <div className="flex flex-wrap gap-1.5">
      {PRESETS.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onPreset(p.id)}
          className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${preset === p.id ? 'bg-[#1a5c3b] text-white border-[#1a5c3b]' : 'bg-white text-gray-700 border-gray-200 hover:border-[#1a5c3b] hover:text-[#1a5c3b]'}`}
          data-testid={`period-${p.id}`}
        >
          {p.label}
        </button>
      ))}
    </div>
    <div className={`flex items-center gap-2 rounded-full border px-3 py-1 bg-white ${preset === 'custom' ? 'border-[#1a5c3b]' : 'border-gray-200'}`}>
      <CalendarRange className="w-4 h-4 text-[#1a5c3b] shrink-0" />
      <input type="date" value={start} max={end} onChange={(e) => e.target.value && onCustom(e.target.value, end)} className="text-sm bg-transparent outline-none min-w-0" data-testid="period-start" />
      <span className="text-gray-400 text-sm">to</span>
      <input type="date" value={end} min={start} onChange={(e) => e.target.value && onCustom(start, e.target.value)} className="text-sm bg-transparent outline-none min-w-0" data-testid="period-end" />
    </div>
  </div>
);
